export enum BookingPageType {
    LiveServices = 'LiveServices',
    Transform = 'Transform'
}
